/**
 * Diagnostico Service - N129 fase 2
 *
 * Logs de diagnostico que o app offline sobe sozinho no sync (fase 1).
 * Leitura e MASTER-only no backend (T30: o extrato tem codigo de produto,
 * lote e quantidade = dado de cliente). O gating de tela aqui e so cortesia.
 */
import apiClient from './apiClient';

export interface Diagnostico {
  id: number;
  usuario_id: number;
  usuario_nome: string;
  arquivo_origem: string;
  linhas: number;
  tamanho_bytes: number;
  app_version: string;
  plataforma: string;
  device_name: string;
  created_at: string;
}

export interface DiagnosticoListResponse {
  items: Diagnostico[];
  total: number;
  page: number;
  page_size: number;
  total_pages: number;
}

export const listarDiagnosticos = async (
  page = 1,
  page_size = 20,
): Promise<DiagnosticoListResponse> => {
  const response = await apiClient.get<DiagnosticoListResponse>('/diagnosticos', {
    params: { page, page_size },
  });
  return response.data;
};

/** Baixa o .log.gz. Nao existe URL publica do arquivo — passa pelo endpoint. */
export const baixarDiagnostico = async (id: number): Promise<void> => {
  const response = await apiClient.get(`/diagnosticos/${id}/download`, {
    responseType: 'blob',
  });
  const url = window.URL.createObjectURL(response.data as Blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `diagnostico_${id}.log.gz`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  window.URL.revokeObjectURL(url);
};

export const formatBytes = (bytes: number): string => {
  if (!bytes) return '0 B';
  const units = ['B', 'KB', 'MB', 'GB'];
  const i = Math.min(Math.floor(Math.log(bytes) / Math.log(1024)), units.length - 1);
  const valor = bytes / Math.pow(1024, i);
  return `${i === 0 ? valor : valor.toFixed(1)} ${units[i]}`;
};
